/** @format */

import {
	ApplicationState,
	initialApplicationState,
	ProblemSubType,
	SearchCoordinatesPayload,
	ProblemMenuConfig,
	MenuItem,
	ProblemType,
	User,
	Group,
	ProblemSource,
	ProblemStatus,
	Role,
	ApplicationStatus,
	initialArcGisToken,
	ProblemReceived,
} from './application.state';
import { ApplicationAction, ApplicationActionType, WindowSize, LookupOwnerSuccess, SetProblemAttachmentsImages } from './application.action';
import { ActivityList } from 'src/app/models/activity';
import { Problem, PhoneType } from 'src/app/models/problem';
import { Attachment } from 'src/app/models/attachment';

// const getImages = (payload: Attachment[]) => {

//   const galleryImages: NgxGalleryImage[] = [];
//   const imageExtensions = ['jpg', 'png', 'tif', 'tiff'];
//   const images = payload.filter(p => p.fileType.toLowerCase() === 'jpg' || p.fileType.toLowerCase() === 'png'
//     || p.fileType.toLowerCase() === 'tiff' || p.fileType.toLowerCase() === 'tif');
//   const docUrl = ''; // TODO: put document URL here
//   if (images.length > 0) {
//     images.forEach(img => {
//       galleryImages.push({
//         small: docUrl + img.attachment_Name + '.' + img.fileType.toLowerCase(),
//         medium: docUrl + img.attachment_Name + '.' + img.fileType.toLowerCase(),
//         big: docUrl + img.attachment_Name + '.' + img.fileType.toLowerCase()
//       };
//     };
//   }

//   return galleryImages;
// };

export function applicationReducer(state: ApplicationState = initialApplicationState, action: ApplicationAction): ApplicationState {
	switch (action.type) {
		case ApplicationActionType.Idle:
			return {
				...state,
				status: ApplicationStatus.Idle,
			};

		case ApplicationActionType.Layer:
			return {
				...state,
				status: ApplicationStatus.Layer,
			};

		case ApplicationActionType.SetMenuOption:
			return {
				...state,
				menu: action.payload,
			};

		case ApplicationActionType.SetMenuDictionaries:
			return {
				...state,
				menuDictionaries: createDictionary(action.payload),
			};

		case ApplicationActionType.SetProblemNeighborScope:
			return {
				...state,
				problemNeighborScope: [],
			};

		case ApplicationActionType.SetProblemNeighborScopeSuccess:
			return {
				...state,
				problemNeighborScope: action.payload.problemNeighborScope,
			};

		case ApplicationActionType.GetProblemNeighbors:
			return {
				...state,
				problemNeighbors: [],
			};

		case ApplicationActionType.GetProblemNeighborsSuccess:
			return {
				...state,
				problemNeighbors: action.payload.success,
			};

		case ApplicationActionType.SetProblems:
			return {
				...state,
				problems: action.payload.sort(
					(p1: Problem, p2: Problem) => new Date(p2.reportedDate).getTime() - new Date(p1.reportedDate).getTime(),
				),
			};

		case ApplicationActionType.SetDashBoardProblems:
			return {
				...state,
				problemDashboard: action.payload,
			};

		case ApplicationActionType.SetProblemsFiltered:
			return {
				...state,
				problemsFiltered: action.payload,
			};

		// The sorting here looks wrong - trying to see if SetActivity usage can be stopped
		// case ApplicationActionType.SetActivity:
		//   return {
		//     ...state,
		//     activities: [......state.activities, action.payload]
		//       .sort((a: ActivityList, b: ActivityList) => new Date(b.activityDate).getTime() - new Date(a.activityDate).getTime())
		//   };

		case ApplicationActionType.SetAccess:
			return {
				...state,
				access: action.payload,
			};

		case ApplicationActionType.SetActivities:
			return {
				...state,
				activities: action.payload,
			};

		case ApplicationActionType.SetAsset:
			return {
				...state,
				asset: action.payload,
			};

		case ApplicationActionType.SetTasks:
			return {
				...state,
				tasks: action.payload,
			};

		case ApplicationActionType.SetNewCaseNo:
			return {
				...state,
				lastCreatedCaseNo: action.payload,
			};

		case ApplicationActionType.SetDashboardView:
			return {
				...state,
				dashboardView: action.payload,
			};

		case ApplicationActionType.SetDashboardTabView:
			return {
				...state,
				dashboardTabView: action.payload,
			};

		case ApplicationActionType.SelectProblem:
			return {
				...state,
				selectedProblem: action.payload,
			};

		case ApplicationActionType.ToggleCategoryExpanded:
			return {
				...state,
				categorySubType: action.payload,
			};

		// case ApplicationActionType.ToggleProblemExpanded:
		//   const idx = ...state.problems.findIndex(p => p.problemNo === action.payload);
		//   return {
		//     ...state,
		//     problems: [...state.problems.slice(0, idx),
		//     { ...state.problems[idx], isExpanded: !...state.problems[idx].isExpanded },
		//      ...state.problems.slice(idx + 1)]
		//      };

		case ApplicationActionType.SetNoMapLocation:
			return {
				...state,
				noPin: action.payload,
			};

		case ApplicationActionType.UpdateWindowSize:
			const windowSize = action.payload as WindowSize;
			return {
				...state,
				windowInnerHeight: windowSize.windowInnerHeight,
				windowInnerWidth: windowSize.windowInnerWidth,
			};

		case ApplicationActionType.SetCategorySubType:
			return {
				...state,
				categorySubType: action.payload,
			};

		case ApplicationActionType.SetNewCaseMenu:
			return {
				...state,
				newCaseMenu: (action.payload as ProblemMenuConfig[]).filter((pmc) => pmc.active),
			};

		case ApplicationActionType.AddCaseGotoStep:
			return {
				...state,
				caseStep: action.payload,
			};

		case ApplicationActionType.SetSelectedProblemType:
			const problemT = action.payload as ProblemSubType;
			return {
				...state,
				selectedProblemType: {
					problemType_Id: problemT.problemType_Id,
					problemType_Name: problemT.problemType_Name,
				},
			};

		case ApplicationActionType.SetAllProblemSubTypes:
			return {
				...state,
				problemSubTypes: action.payload,
			};

		case ApplicationActionType.GetProblemHistorySuccess:
			return {
				...state,
				problemHistory: action.payload,
			};

		case ApplicationActionType.GetProblemHistoryError:
			return {
				...state,
				problemHistory: [],
			};

		case ApplicationActionType.SetDescriptionHistory:
			return {
				...state,
				descriptionHistory: action.payload,
			};

		case ApplicationActionType.SetRapUsers:
			return {
				...state,
				rapUsers: action.payload,
			};

		case ApplicationActionType.SetProblemContacts:
			return {
				...state,
				problemContacts: action.payload ? action.payload : {},
			};

		case ApplicationActionType.SetZoneLookupOnly:
			return {
				...state,
				zoneLookupOnly: action.payload,
			};

		case ApplicationActionType.SetSearchCoordinates:
			return {
				...state,
				searchCoordinate: action.payload as SearchCoordinatesPayload,
			};

		// case ApplicationActionType.SearchCoordinatesSuccess:
		//   return {
		//    ...state,
		//     searchCoordinate: (action.payload as SearchCoordinatesPayload)
		//   };

		case ApplicationActionType.LookupOwnerSuccess:
			return {
				...state,
				propertyOwners: (action as LookupOwnerSuccess).payload.success,
			};

		case ApplicationActionType.LookupOwnerReset:
			return {
				...state,
				propertyOwners: [],
			};

		case ApplicationActionType.SearchCoordinatesError:
			return {
				...state,
				searchCoordinate: null,
			};

		case ApplicationActionType.CancelActivitySuccess:
			return {
				...state,
				activities: action.payload,
			};

		case ApplicationActionType.CancelActivityError:
			return {
				...state,
				activities: [],
			};

		case ApplicationActionType.Search:
			return {
				...state,
				searchResults: [],
			};

		case ApplicationActionType.SearchResultsSuccess:
			return {
				...state,
				searchResults: action.payload,
			};

		case ApplicationActionType.SearchResultsError:
			return {
				...state,
				searchResults: [],
			};

		case ApplicationActionType.SaveSearchQuerySuccess:
			return {
				...state,
				savedSearchQueries: [...state.savedSearchQueries, action.payload],
			};

		case ApplicationActionType.SaveSearchQueryError:
			return {
				...state,
				savedSearchQueries: [],
			};

		case ApplicationActionType.GetAllSearchQueries:
			return {
				...state,
				savedSearchQueries: [],
			};

		case ApplicationActionType.GetAllSearchQueriesSuccess:
			return {
				...state,
				savedSearchQueries: action.payload,
			};

		case ApplicationActionType.GetAllSearchQueriesError:
			return {
				...state,
				savedSearchQueries: [],
			};

		case ApplicationActionType.RemoveSavedSearchQuerySuccess:
			return {
				...state,
				savedSearchQueries: state.savedSearchQueries.filter((query) => query.savedQuery_Id !== action.payload.savedQuery_Id),
			};

		// case ApplicationActionType.GetAllProblemLinkedCases:
		//   return {
		//    ...state,
		//     linkedCases: []
		//   };

		// case ApplicationActionType.GetProblemLinkedCases:
		//   return {
		//    ...state,
		//     linkedCases: []
		//   };

		case ApplicationActionType.GetProblemLinkedCasesSucccess:
			return {
				...state,
				linkedCases: action.payload,
			};

		case ApplicationActionType.GetProblemLinkedCasesAddMenuSucccess:
			return {
				...state,
				linkedCasesAddMenu: action.payload,
			};

		case ApplicationActionType.AddProblemLinkedCaseSuccess:
			return {
				...state,
				linkedCases: action.payload.linkedCase,
			};

		case ApplicationActionType.UnlinkProblemCaseSuccess:
			return {
				...state,
				linkedCases: action.payload,
			};

		case ApplicationActionType.UpdateLinkedCaseNotesSuccess:
			return {
				...state,
				linkedCases: action.payload,
			};

		case ApplicationActionType.GetProblemAttachmentsSuccess:
			return {
				...state,
				attachments: action.payload,
			};

		case ApplicationActionType.GetProblemAttachmentsError:
			return {
				...state,
				attachments: [],
			};

		case ApplicationActionType.RemoveProblemAttachments:
			return {
				...state,
				attachments: state.attachments.filter((attachment) => attachment.docNumber.toString() !== action.payload),
			};

		case ApplicationActionType.RemoveProblemAttachmentsImages:
			return {
				...state,
				galleryImages: state.galleryImages.filter((image) => image.label !== action.payload),
			};

		case ApplicationActionType.SetProblemAttachmentsImages:
			return {
				...state,
				galleryImages: state.galleryImages.concat(action.payload),
			};

		case ApplicationActionType.SetProblemAttachmentsImagesNull:
			return {
				...state,
				galleryImages: [],
			};

		case ApplicationActionType.SetNoProblems:
			return {
				...state,
				noProblems: action.payload,
			};

		case ApplicationActionType.SetCityworksTransferMap:
			return {
				...state,
				cityworksTransferMapping: action.payload,
			};

		case ApplicationActionType.CityworksTransferRequest:
			return {
				...state,
				transferringToCityworks: true,
			};

		case ApplicationActionType.TransferringToCityworks:
			return {
				...state,
				transferringToCityworks: action.payload,
			};

		case ApplicationActionType.CityworksRequestView:
			return {
				...state,
				isGettingCityworksViewData: true,
			};

		case ApplicationActionType.CityworksRequestViewSuccess:
			return {
				...state,
				cityworksRequestedView: action.payload,
				isGettingCityworksViewData: false,
			};

		case ApplicationActionType.CityworksRequestViewError:
			return {
				...state,
				isGettingCityworksViewData: false,
			};

		case ApplicationActionType.ClearCityworksRequestView:
			return {
				...state,
				cityworksRequestedView: {
					description: '',
					status: '',
					priority: '',
					submitToName: '',
					dateSubmitTo: new Date(),
					details: '',
					closedByName: '',
					comments: [],
					dateTimeClosed: new Date(),
					images: [],
					workOrders: [],
					resolutionDescription: '',
					text6: '',
				},
			};

		case ApplicationActionType.CreatingCodeCase:
			return {
				...state,
				creatingCodeCase: action.payload,
			};

		case ApplicationActionType.SetInProgressActivity:
			return {
				...state,
				inProgressActivity: action.payload,
			};

		case ApplicationActionType.SetInProgressMyTask:
			return {
				...state,
				inProgressMyTask: action.payload,
			};

		case ApplicationActionType.ScrollToResults:
			return {
				...state,
				scrollToResults: action.payload,
			};

		case ApplicationActionType.SetAppView:
			return {
				...state,
				appView: action.payload,
			};

		case ApplicationActionType.SetViewLoading:
			return {
				...state,
				viewLoading: action.payload,
			};

		case ApplicationActionType.RenewArcGisTokenSuccess:
			return {
				...state,
				arcGisToken: action.payload.success,
			};

		case ApplicationActionType.RenewArcGisTokenError:
			return {
				...state,
				arcGisToken: initialArcGisToken,
			};

		case ApplicationActionType.IsNation:
			return {
				...state,
				isNation: action.payload,
			};

		case ApplicationActionType.SetProfilePicture:
			return {
				...state,
				profilePicture: action.payload,
			};

		case ApplicationActionType.SetIsAdminUser:
			return {
				...state,
				admin: {
					...state.admin,
					isAdmin: action.payload,
				},
			};

		case ApplicationActionType.SetUsers:
			return {
				...state,
				admin: {
					...state.admin,
					users: action.payload,
				},
			};

		case ApplicationActionType.SetAdminSection:
			return {
				...state,
				admin: {
					...state.admin,
					section: action.payload,
				},
			};

		case ApplicationActionType.SetGroups:
			return {
				...state,
				admin: {
					...state.admin,
					groups: action.payload,
				},
			};

		case ApplicationActionType.SetRoles:
			return {
				...state,
				admin: {
					...state.admin,
					roles: action.payload,
				},
			};

		case ApplicationActionType.SetADUsersList:
			return {
				...state,
				admin: {
					...state.admin,
					adminADUserList: action.payload,
				},
			};

		case ApplicationActionType.GetRecentProblemsList:
			return {
				...state,
				linkedCases: [],
			};

		case ApplicationActionType.SetRecentProblemsList:
			return {
				...state,
				recentProblems: action.payload,
			};

		default:
			return state;
	}
}

function createDictionary(menu: MenuItem) {
	const probTypes: Map<number, ProblemType> = new Map<number, ProblemType>();
	menu.allProblemTypeList.forEach((pt) => {
		probTypes.set(pt.problemType_Id, pt);
	});

	const allUsers: Map<number, User> = new Map<number, User>();
	menu.allUsersList.forEach((u) => {
		allUsers.set(u.user_Id, u);
	});

	const groupList: Map<number, Group> = new Map<number, Group>();
	menu.problemGroupList.forEach((g) => {
		groupList.set(g.group_Id, g);
	});

	const sourceList: Map<number, ProblemSource> = new Map<number, ProblemSource>();
	menu.problemSourceList.forEach((s) => {
		sourceList.set(s.problemSource_Id, s);
	});

	const receivedFromList: Map<number, ProblemReceived> = new Map<number, ProblemReceived>();
	menu.problemReceivedFromList.forEach((rf) => {
		receivedFromList.set(rf.problemReceivedFrom_Id, rf);
	});

	const statusList: Map<number, ProblemStatus> = new Map<number, ProblemStatus>();
	menu.problemStatusList.forEach((s) => {
		statusList.set(s.problemStatus_Id, s);
	});

	const roleList: Map<number, Role> = new Map<number, Role>();
	menu.problemRoleList.forEach((r) => {
		roleList.set(r.role_Id, r);
	});

	return {
		problemTypes: probTypes,
		allUsers: allUsers,
		groupList: groupList,
		sourceList: sourceList,
		receivedFromList: receivedFromList,
		statusList: statusList,
		roleList: roleList,
	};
}
